import {
    StyleSheet,
    Platform
} from "react-native";

const stylesheet = StyleSheet.create({
    latin: {
        ...Platform.select({
            default: {
                direction: "ltr"
            },
            web: {
            }
        })
    },
    container: {
        flexDirection: "row",
        minWidth: 0
    },
    stem: {
        flexShrink: 1,
        minWidth: 0
    },
    extension: {
        flexShrink: 0
    }
});
export default stylesheet;
